module.exports = __webpack_public_path__ + "static/media/notes-of-love-five.b059d4a6.png";